import '../shared/types';

/**
 * @typedef {object} PerformanceChartState
 * @property {PerformanceChartNavState} nav
 * @property {PerformanceChartDataTypeState} dataType
 * @property {PerformanceChartRequestDetails[]} requests
 * @property {any} data
 */

/**
 * @typedef {object} PerformanceChartNavState
 * @property {string} category
 * @property {object} season
 * @property {number|null} season.id
 */

/**
 * @typedef {object} PerformanceChartDataTypeState
 * @property {'totals'|'perGame'} dataType.type
 */

/**
 * @typedef {object} PerformanceChartRequestDetails
 * @property {string} playerId
 * @property {string} seasonId
 * @property {'season'|'career'} type
 */
